import { Component, EventEmitter, Inject, OnDestroy, Output } from '@angular/core';
import { AppEventService } from '../../events.service';
import { AppStudentsService } from '../../../students/students.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { FormControl } from '@angular/forms';



@Component({
  selector: 'app-scheduled-hero-event-scan-student-dialog',
  templateUrl: './scheduled-hero-event-scan-student-dialog.component.html',
  styleUrls: ['./scheduled-hero-event-scan-student-dialog.component.scss'],
})
export class ScheduledHeroEventScanStudentDialogComponent
  extends BaseComponent
  implements OnDestroy {
  public studentExtId = new FormControl('');

  constructor(
    public eventsService: AppEventService,
    public studentsService: AppStudentsService,
    public dialogRef: MatDialogRef<ScheduledHeroEventScanStudentDialogComponent>,
    public toastService: AppToastManagerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      scheduledHeroEventId: number;
      onClose: () => Promise<void>;
      updateStudent: (studentExtId: string) => void;
    }
  ) {
    super();
  }

  async ngOnDestroy() {
    await this.data.onClose();
  }

  async handleClose() {
    await this.data.onClose();
    this.dialogRef.close();
  }

  public async checkInOutStudent() {
    this.data.updateStudent(this.studentExtId.value);
    await this.data.onClose();
    this.dialogRef.close();
  }
}
